import { useRef } from "react";
import "./Our_client_partners.css";

// Swiper
import { Autoplay, Grid, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Swiper styles
import "swiper/css/grid";
import "swiper/css";
import "swiper/css/navigation";

import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TrustedCommunitys } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";

const Our_client_partners = () => {
  const swiperRef = useRef(null);
  const sliderData = [
    { id: 1, img: "/assets/images/home/trusted_communities/img-1.png" },
    { id: 2, img: "/assets/images/home/trusted_communities/img-2.png" },
    { id: 3, img: "/assets/images/home/trusted_communities/img-3.png" },
    { id: 4, img: "/assets/images/home/trusted_communities/img-1.png" },
    { id: 5, img: "/assets/images/home/trusted_communities/img-2.png" },
  ];

  const { IMG_URL } = useContext(Context);

  const [trusted, setTrusted] = useState([]);

  const getTrusted = async () => {
    const res = await TrustedCommunitys();
    if (res?.success) {
      setTrusted(res.data);
    }
  };
  useEffect(() => {
    getTrusted();
  }, []);

  //   const [swiperInstance, setSwiperInstance] = useState(null);
  //   const handleMainSliderClick = (direction) => {
  //   if (swiperInstance) {
  //     if (direction === "prev") {
  //       swiperInstance.slidePrev();
  //     } else if (direction === "next") {
  //       swiperInstance.slideNext();
  //     }
  //   }
  // };

  return (
    <section className="Our_client_partners">
      <div className="custom_container">
        <div className="Trusted_Communities_div">
          <div className="row me-0 ms-0 align-items-center">
            <div className="col-lg-4 col-md-5">
              <div className="Trusted_Communities_text_holder">
                <Common_heading
                  heading={"OUR CLIENTS AND PARTNERS"}
                  subHeading={"ACROSS THE BIG PREMISES, ACROSS THE COUNTRY"}
                />

                <p className="Trusted_Communities_text">
                  Welcome to AYZAIR, a leading industry innovator with a rich
                  history empowering industries and driving progress.
                </p>

                {/* Custom Navigation */}
                <div className="custom_nav">
                  <button
                    className="nav_btn"
                    onClick={() => swiperRef.current?.slidePrev()}
                    // onClick={() => handleMainSliderClick("prev")}
                    type="button"
                  >
                    <FontAwesomeIcon
                      icon={faAngleLeft}
                      className="font_angle"
                    />
                  </button>

                  <button
                    className="nav_btn right_angle_btn"
                    onClick={() => swiperRef.current?.slideNext()}
                    type="button"
                    // onClick={() => handleMainSliderClick("next")}
                  >
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      className="font_angle"
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-7 swiper_holder">
              <Swiper
                modules={[Grid, Navigation, Autoplay]}
                grid={{
                  rows: 2,
                  fill: "row",
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                spaceBetween={20}
                slidesPerView={5}
                navigation={false}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                loop={false}
                watchOverflow={true}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
                className="trustedSwiper"
              >
                {trusted.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="trusted_card">
                      <img
                        src={IDS?.IMG_URL + item?.image}
                        alt="community"
                        className="card_img"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_client_partners;
